"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = exports.initialPagination = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const Actions = require("../../actionTypes/customer/list");
exports.initialPagination = {
    limit: 20,
    offset: 0
};
exports.initialState = Object.assign(Object.assign({ status: 'STANDBY', error: undefined, type: 'ADMIN', list: [] }, exports.initialPagination), { filterBy: 'all-clients', selected: [], orderDropdownToggled: false, filterDropdownToggled: false });
//#endregion
//#region LENS
const statusLens = monocle.Lens.fromProp('status');
const listLens = monocle.Lens.fromProp('list');
const typeLens = monocle.Lens.fromProp('type');
const errorLens = monocle.Lens.fromProp('error');
const selectedLens = monocle.Lens.fromProp('selected');
const filterByLens = monocle.Lens.fromProp('filterBy');
const orderDropdownToggledLens = monocle.Lens.fromProp('orderDropdownToggled');
const filterDropdownToggledLens = monocle.Lens.fromProp('filterDropdownToggled');
const methods = {};
exports.methods = methods;
methods[Actions.FETCH_CUSTOMER_LIST_REQUEST] = (state, action) => statusLens.set('FETCHING')(state);
methods[Actions.FETCH_CUSTOMER_LIST_SUCCESS] = (state, action) => fp.function.compose(statusLens.set('FETCHED'), typeLens.set(action.payload.type), listLens.set(action.payload.customers))(state);
methods[Actions.FETCH_CUSTOMER_LIST_FAILED] = (state, action) => fp.function.compose(statusLens.set('FAILED'), errorLens.set(action.payload))(state);
methods[Actions.SET_FILTER_BY] = (state, action) => filterByLens.set(action.payload)(state);
methods[Actions.SELECT_ITEMS] = (state, action) => selectedLens.modify((list) => action.payload.reduce((r, i) => {
    if (r.indexOf(i) === -1)
        return [...r, i];
    return r;
}, list))(state);
methods[Actions.UNSELECT_ITEMS] = (state, action) => selectedLens.modify((r) => r.filter((i) => action.payload.indexOf(i) === -1))(state);
methods[Actions.TOGGLE_SORT_BY_DROPDOWN] = (state) => orderDropdownToggledLens.modify((val) => !val)(state);
methods[Actions.TOGGLE_FILTERS_DROPDOWN] = (state) => filterDropdownToggledLens.modify((val) => !val)(state);
//# sourceMappingURL=list.js.map